module.exports = __webpack_public_path__ + "img/loading.70bc0562.png";